export default __webpack_public_path__ + "static/media/OnlineStore.086813dc.mov";